import type React from "react";
import { i18nFilter } from "app/filters/i18nFilter";
import { AssetsTooltipContent } from "app/pages/digital-suite/home-page/components/CustomAssets/AssetsTooltipContent/AssetsTooltipContent";
import { AssetType } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import { allTrackers } from "app/services/track/track";

export const DashboardTrackerTooltipContent: React.FC = () => {
    const i18n = i18nFilter();

    return (
        <AssetsTooltipContent
            assetType={AssetType.DASHBOARD}
            title={i18n("digitalmarketing.homepage.custom_assets.empty_state.tooltip.title.dashboards")}
            videoUrl={"https://vimeo.com/433347498"}
            videoThumbnailSrc={"/images/custom-assets/dashboard-info-thumbnail.png"}
            learnMoreUrl={"https://support.similarweb.com/hc/en-us/articles/360010602497-Build-a-Dashboard"}
            onVideoOpen={() => allTrackers.dispatchTrackEvent("Button", "click", "My Assets/dashboard toturial")}
        />
    );
};
